import { Component } from '@angular/core';

interface Transaction {
    item: string;
    cost: number;
}

@Component({
    selector: 'app-multiple-header-footer-table',
    templateUrl: './multiple-header-footer-table.component.html',
    styleUrls: ['./multiple-header-footer-table.component.scss']
})
export class MultipleHeaderFooterTableComponent {

    displayedColumns: string[] = ['item', 'cost'];
    transactions: Transaction[] = [
        {item: 'Beach ball', cost: 4},
        {item: 'Towel', cost: 5},
        {item: 'Frisbee', cost: 2},
        {item: 'Sunscreen', cost: 4},
        {item: 'Swim suit', cost: 15},
    ];

    /** Gets the total cost of all transactions. */
    getTotalCost() {
        return this.transactions.map(t => t.cost).reduce((acc, value) => acc + value, 0);
    }

}